module.exports = __webpack_public_path__ + "img/22jul3.9d84ad9e.jpeg";